export default __webpack_public_path__ + "static/media/release1.30929c4a.jpeg";